import React from 'react';
import classNames from 'classnames';
import FavoriteBorderIcon from '@material-ui/icons/FavoriteBorder';
import FavoriteIcon from '@material-ui/icons/Favorite';
import classnames from './mobile-favourite-button.scss';
export const MobileFavoriteButton = ({
  isFavourite,
  productId,
  isLoggedIn,
  onProductFavouriteClick
}) => {
  return /*#__PURE__*/React.createElement("div", {
    className: classnames.container
  }, /*#__PURE__*/React.createElement("div", {
    onClick: () => onProductFavouriteClick(isLoggedIn)({
      productId,
      nextIsFavourite: !isFavourite
    }),
    className: classNames(classnames.button, {
      [classnames.isFavourite]: isFavourite
    })
  }, isFavourite ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(FavoriteIcon, null), " Favorited") : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(FavoriteBorderIcon, null), " Favorite")));
};